export default "__VITE_ASSET__8d26f428__"